<template>
  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="团购名称:" prop="name">
            <span>{{formData.groupName}}</span>
          </el-form-item>
          <el-form-item label="团购封面:" >
            <img :src="formData.groupimg" class="groupimg">
          </el-form-item>
          <el-form-item label="分享海报:">
            <img :src="formData.posterimg" class="groupimg">
          </el-form-item>
          <el-form-item label="团购banner">
            <img :src="item.bannerImgUrl" v-for="item in groupimgs" class="groupimg">
          </el-form-item>
          <el-form-item label="单独全价:" >
            <span>{{formData.singlePrice}}</span>
            <span style="margin-left: 30px">三人团价：</span>
            <span>{{formData.groupPrice}}</span>
          </el-form-item>

          <!--图文教程-->
          <el-form-item label="团购视频">

          </el-form-item>
          <el-table
            :data="tableData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="视频名称">
            </el-table-column>
            <el-table-column
              prop="timeLength"
              label="时长">
            </el-table-column>
          </el-table>
          <el-form-item label="添加课程介绍" style="margin-top: 30px">
            <img :src="item.courseImgUrl" v-for="item in posterimgs" class="groupimg">
          </el-form-item>

        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import groupCourse from '@/components/groupCourse'
  import { getGroupDetail } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        formData:{
          groupName:'',
          groupimg:'',
          posterimg:'',
          singlePrice:'',
          groupPrice:'',
        },
        groupimgs:[],
        posterimgs:[],
        tableData:[],
      }
    },
    components: {
      headTop,groupCourse
    },
    methods:{

    },
    activated () {
      let params = {
        id:this.$route.query.id
      }
      getGroupDetail(params).then(res=>{
        if (res.code == 200) {
          this.formData.groupName = res.data.strategyTitle
          this.formData.groupimg = res.data.coverImgUrl
          this.formData.posterimg = res.data.shareImgUrl
          this.groupimgs = res.data.drawingGroupStrategyBannerList
          this.formData.singlePrice = res.data.singlePrice
          this.formData.groupPrice = res.data.groupPrice
          this.posterimgs = res.data.drawingGroupStrategyCourseImageList
          this.tableData = res.data.drawingGroupGoodsList
          for (let i = 0; i < res.data.drawingGroupGoodsList.length; i++) {
            let drawingGroupGoodsSaveParams = {
              goodsCount: 1,
              goodsId: res.data.drawingGroupGoodsList[i].goodsId,
            }
            this.goodList.push(drawingGroupGoodsSaveParams)
          }
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      }).catch(error=>{
        console.log(error);
      })
    },

  }
</script>
<style lang="less">
  .groupimg{
    width: 178px!important;
    height: 178px!important;
  }
</style>



// WEBPACK FOOTER //
// src/page/seegroup.vue